/* Global imports. */
import React, { useState, useEffect } from 'react';
import { Link } from "gatsby"
import EditionImage from "@components/EditionImage"
import { PanMacmillanEdition } from "@src/models/panmacmillan";
import { getFormat } from "@src/onix"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface Props {
    slidesToShow?: number;
    editions?: PanMacmillanEdition[];
    componentID? : string;
    referringSlug?: string;
    showContributor?: boolean;
}


function BookSlider({ editions = [], componentID, referringSlug, slidesToShow = 3, showContributor = false }: Props) {

    const showDots = (slidesToShow: number) => {
      return editions.length > slidesToShow ? true : false;
    
    }
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      centerMode: false,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        }
      ]
    };

    const [sliderStyle, setSliderStyle] = useState('');

    useEffect(() => {
      const updateSliderStyle = () => {
        if (editions.length < slidesToShow) {
          if(window.innerWidth > 900) {
            setSliderStyle('no-transform');
          } else {
            setSliderStyle('');
          }
        }
      };
    
      // Update style on mount and when editions or slidesToShow changes
      updateSliderStyle();
    
      // Update style whenever the window is resized
      window.addEventListener('resize', updateSliderStyle);
    
      // Clean up the event listener when the component is unmounted or when editions or slidesToShow changes
      return () => {
        window.removeEventListener('resize', updateSliderStyle);
      };
    }, [editions, slidesToShow]); 


    return (
      <Slider {...settings} className={sliderStyle}>
          {editions && editions.map(edition => {
            if (edition.node !== undefined) {
              edition = edition.node;
            }
            const editionTitle = edition.titleFull
            const slug = `/${edition.fields.slug}`
        
            return (
                <Link key={edition.id || slug} className="flex no-underline group min-w-[175px] p-5 pb-0" data-ref-slug={referringSlug} to={`/${edition.fields.slug}`} data-slug={`/${edition.fields.slug}`} data-ref-component-type={`books-by`}  data-title={editionTitle} data-isbn={edition.isbn} data-author={edition.primaryContributorName} data-format={getFormat(edition.format)} >
                  <figure className="book-preview-contain text-center grid grid-rows-1">
                    <EditionImage isbn={edition.isbn} altImagePath={edition.remoteImage && edition.remoteImage.publicURL} size="S" title={editionTitle} width={edition.dimensions && edition.dimensions.width} height={edition.dimensions && edition.dimensions.height} loading="lazy" classNames="w-full drop-shadow-book" />
                    <figcaption className="text-center pt-5 ">
                      <h3 className="text-center text-grey-dark text-base font-bold font-sans group-hover:underline decoration-1 mb-0" dangerouslySetInnerHTML={{ __html: editionTitle }} />
                      {showContributor && <h4 className="text-sm font-normal font-['Spectral'] pt-2 group-hover:underline">{edition.primaryContributorName}</h4>}
                    </figcaption>
                  </figure>
                </Link>
            )
          })}
      </Slider>
    );

}

export default BookSlider;